import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b9d03fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "content-container"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "loader" })
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "content-container"
}
const _hoisted_5 = { class: "top-content" }
const _hoisted_6 = { class: "flex-row-centered" }
const _hoisted_7 = { class: "table-container" }

import { ref, Ref, onMounted, computed, provide } from "vue";
import { marketSelection } from "@/services/helpers/Helper";
import TablePersistentChecking, {
    ITableExpose,
} from "@/components/TablePersistentChecking.vue";
import PaymentItem from "@/Interfaces/Payments/FinalSettlementPaymentItem";
import FinalSettlementPaymentPopUp from "@/components/FinalSettlementPaymentPopUp.vue";
import { finalSettlementPayments } from "@/services/network";
import MarketSelector from "@/components/MarketSelector.vue";
import useNotifier from "@/services/composables/Notifier";
import useNotifierWithErrFormatter from "@/services/composables/NotifierWithErrFormatter";


export default /*#__PURE__*/_defineComponent({
  __name: 'FinalSettlementPayments',
  setup(__props) {

const cols: (keyof PaymentItem)[] = [
    "invoiceId",
    "balance",
    "amountTotal",
    "issueDate",
    "dueDate",
    "balanceDateUpdated",
];
const labels = [
    "Invoice Id",
    "Balance",
    "Amount Total",
    "Issue Date",
    "Due Date",
    "Balance Date Updated",
];

const page: Ref<number> = ref(1);
const rowCount: Ref<number> = ref(50);
provide("page", page);
provide("rowCount", rowCount);

// Table
const isLoading = ref(false);
const allPayments = ref<PaymentItem[]>([]);

const displayedPayments = computed(() =>
    allPayments.value
);
const checkedRow = ref<PaymentItem>();
const selectedRow = ref<PaymentItem>();
const table = ref<ITableExpose<PaymentItem>>();
    

onMounted(async () => {
    marketSelection.value = "GB";
    getPayments();
});
async function getPayments() {
    //const errorType = 'Getting Final Settlement Invoice Payments from API';
    try {
        isLoading.value = true;
        allPayments.value = (await finalSettlementPayments.get({market: marketSelection.value})).data.map(
            (x) => new PaymentItem(x)
        );
        updateSelection();
    } catch (error) {
        useNotifierWithErrFormatter().error({error, errorType: "Getting Final Settlements"})
    } finally {
        isLoading.value = false;
    }
}
const updateSelection = () => {
    checkedRow.value = undefined;
    selectedRow.value = undefined;
};
const proceedToPayment = () => {
    if (checked.value.length < 1) useNotifier().notify({ msg: "No item selected" });
    else {
        selectedRow.value = checked.value[0];
    }
};
const checked: Ref<PaymentItem[]> = computed(() => {
    return table.value?.GetChecked() ? table.value?.GetChecked() : [];
});
function refreshAfterConfirm() {
    getPayments();
    checkedRow.value = undefined;
}

return (_ctx: any,_cache: any) => {
  return (isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(MarketSelector, {
              onChange: getPayments,
              enableSE: ""
            }),
            _createElementVNode("div", { class: "center-buttons" }, [
              _createElementVNode("button", {
                onClick: proceedToPayment,
                class: "incident-nav-button"
              }, " Confirm Payment ")
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(TablePersistentChecking, {
            ref_key: "table",
            ref: table,
            Rows: displayedPayments.value,
            Cols: cols,
            Labels: labels,
            HasCheckBox: true,
            SingleSelection: true
          }, null, 8, ["Rows"])
        ]),
        _createVNode(FinalSettlementPaymentPopUp, {
          modelValue: selectedRow.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedRow).value = $event)),
          onConfirm: refreshAfterConfirm
        }, null, 8, ["modelValue"])
      ]))
}
}

})